<!-- ScrollToTop.vue -->
<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const showButton = ref(false)
const scrollThreshold = 300

const checkScroll = () => {
  showButton.value = window.scrollY > scrollThreshold
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

onMounted(() => {
  window.addEventListener('scroll', checkScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', checkScroll)
});
</script>

<template>
  <Transition name="fade">
    <button 
      v-show="showButton" 
      @click="scrollToTop"
      class="scroll-top-button"
      aria-label="Scroll to top"
    >
      <font-awesome-icon icon="arrow-up" />
    </button>
  </Transition>
</template>

<style scoped>
@import '../../assets/styles/online/OnlineMain.css';
</style>

